import { Dialog, styled } from "@mui/material";

export const BaseFormModalWrapper = styled(Dialog)<{ location: string }>(({ theme, location }) => {
    return {
        "& h2": {
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: 24,
            lineHeight: "normal",
            color: "#791377",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            padding: 0,
            flex: 1,
            width: "-webkit-fill-available"
        },
        "& .icon-button-box": {
            display: "flex",
            justifyContent: "flex-end",
            padding: "var(--basic-padding) var(--basic-padding) 0"
        },
        "& .MuiIconButton-root": {
            background: "#828683",
            color: "#FFFFFF",
            "&:hover": {
                background: "#828683",
                color: "#FFFFFF",
            }
        },
        "& .modal-heading": {
            alignItems: "center",
            justifyContent: "space-between",
            padding: "var(--basic-padding) var(--basic-padding) 0",
            [theme.breakpoints.down(250)]: {
                "& .MuiButton-root": {
                    width: "100%"
                }
            },
            [theme.breakpoints.down(425)]: {
                gap: "calc(var(--flex-gap)/4)",
                alignItems: "flex-start",
                flexDirection: "column-reverse",
            }
        },
        "& .modal-content": {
            padding: "var(--basic-padding) var(--basic-padding) calc(var(--basic-padding) * 2)",
            "& form": {
                display: "flex",
                flexDirection: "column",
                gap: "calc(var(--flex-gap)/2)",
            },
            "& .MuiFormLabel-root": {
                color: "#373737",
                fontWeight: 500,
                fontSize: "20px",
            },
            "& .MuiInputBase-root": {
                color: "#828683",
                fontWeight: 400,
            }
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
        "& .call-to-action": {
            overflow: "hidden",
            padding: 0,
            marginBlockStart: (location === "password-recovery") ? "unset" : "var(--basic-margin)",
        },
    }
})